export async function getUserChats(username) {
  const tokenObj = JSON.parse(localStorage.getItem('auth-storage'));
  const token = tokenObj?.state?.accessToken;
  const res = await fetch(`/v1/chat/getChats/${username}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  return await res.json();
}

export async function getChatHistory(chatRoomId) {
  const tokenObj = JSON.parse(localStorage.getItem('auth-storage'));
  const token = tokenObj?.state?.accessToken;
  const res = await fetch(`/v1/chat/history/${chatRoomId}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) return [];
  return await res.json();
}